import { useToast } from '@chakra-ui/react';
import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';

async function update(axios: AxiosInstance, id: number): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/task/${id}/check`, {});
  return data;
}

export default function useCheckTaskMutation(id: number, queryKey: QueryKey) {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationFn: () => update(axios, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: (error: any) => {
      manageErrorResponse(toast, error);
    },
  });
}
